// @flow

import "./hotConf"
import Raven from "raven-js"
import { options as ravenOptions, dsn as ravenDsn } from "./raven"
import * as React from "react"
import ReactDOM from "react-dom"
import { configure as mobxConfigure } from "mobx"
import UserStore from "shared/stores/UserStore"
import "./shared/styles/antd.less"
import "@cabonline/shared/styles/global.scss"
import App from "./App"
import { setMapConfig } from "@cabonline/here-maps"
import { hereMapsSettings } from "./shared/utils/constants"

declare var module: any

setMapConfig({
  settings: hereMapsSettings
})

async function resumeSession() {
  await UserStore.loadUserFromCookie()
}

async function bootstrap() {
  mobxConfigure({ enforceActions: "observed" })
  await resumeSession()

  const rootElement = document && document.getElementById("root")

  if (!rootElement) {
    throw new Error("Cannot mount React, no root element found")
  }

  const load = () =>
    /* eslint-disable react/no-render-return-value */
    ReactDOM.render(<App />, rootElement)

  load()
}

Raven.config(ravenDsn, ravenOptions).install()
Raven.context(function() {
  bootstrap()
})
